const categories = {
  CARDIF: "cardif",
  DANNI_AUTO: "danni-auto",
  DANNI_NON_AUTO: "danni-non-auto",
  VITA_INVESTIMENTO: "vita-investimento",
  VITA_PROTEZIONE: "vita-protezione",
  CPI_PPI: "cpi-ppi",
};

const query_type_categories = {
  STANDARD_FASCE: "STANDARD_FASCE",
  FASCE_FILTERED_BY_SOTTOSTANTI: "FASCE_FILTERED_BY_SOTTOSTANTI",
  STANDARD_FOR_MIN_MAX: "STANDARD_FOR_MIN_MAX",
  STANDARD_FOR_MIN_MAX_WITH_JOIN: "STANDARD_FOR_MIN_MAX_WITH_JOIN",
  COUNT: "COUNT",
  PERCENT_FROM_COUNT: "PERCENT_FROM_COUNT",
  BY_YEAR: "BY_YEAR",
  COMBINATION: "COMBINATION",
  COMBINATION_COUNT: "COMBINATION_COUNT",
};

const chart_type_categories = {
  BAR_CHART: "BAR_CHART",
  PIE_CHART: "PIE_CHART",
  GROUPED_BAR_CHART: "GROUPED_BAR_CHART",
  TIPOLOGIA_PREMIO_VITA_PROTEZIONE_BAR_CHART: "TIPOLOGIA_PREMIO_VITA_PROTEZIONE_BAR_CHART",
};

const sorting_methods_categories = {
  ISSUES_DESCRIPTION_COMPARE_ASC: "ISSUES_DESCRIPTION_COMPARE_ASC",
  ISSUES_CODE_COMPARE: "ISSUES_CODE_COMPARE",
  ISSUES_VALUE_COMPARE: "ISSUES_VALUE_COMPARE",
  ISSUES_DESCRIPTION_COMPARE_DESC: "ISSUES_DESCRIPTION_COMPARE_DESC",
  ISSUES_VALUE_MIX_CODE_COMPARE: "ISSUES_VALUE_MIX_CODE_COMPARE",
  ISSUES_VALUE_AND_DESCRIPTION_ASC_COMPARE: "ISSUES_VALUE_AND_DESCRIPTION_ASC_COMPARE",
  ISSUES_DESCRIPTION_COMM_USCITA: "ISSUES_DESCRIPTION_COMM_USCITA",
};

const statistics_categories = {
  MIN: "min",
  AVG: "avg",
  MAX: "max",
  PRODUCTS_COUNT: "products-count",
  PRODUCTS_COUNT_ON_TOT: "products-count-on-tot",
  SUM: "sum",
};

const file_formats = {
  CSV: "csv",
  EXCEL: "xlsx",
  POWERPOINT: "pptx",
};

export { query_type_categories, chart_type_categories, sorting_methods_categories, statistics_categories , file_formats };
export default categories;
